import PageContainer from '@/common/components/PageContainer'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import useQueryGetInactivePlayer from '@/modules/manage-player/api/hooks/useQueryGetInactivePlayer'
import InactivePlayerListing from '@/modules/manage-player/components/InactivePlayer/components/InactivePlayerListing'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useDate } from '@/common/hooks/useDate'
import { useState } from 'react'
import { endOfMonth } from 'date-fns'

type SortOrder = 'asc' | 'desc' | undefined

function InactivePlayerPage() {
	const { pageSize, currentPage, searchQuery, channelFilter } =
		useTablePagination()
	const { date } = useDate()

	const [totalDepositAmountSort, setTotalDepositAmountSort] =
		useState<SortOrder>()
	const [lastDepositAtSort, setLastDepositAtSort] = useState<SortOrder>()
	const [totalDepositTimeSort, setTotalDepositTimeSort] = useState<SortOrder>()
	const [lastLoginSort, setLastLoginSort] = useState<SortOrder>()

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		channelName: channelFilter || undefined,
		inactiveSince: date,
		totalDepositAmountSort,
		lastDepositAtSort,
		totalDepositTimeSort,
		lastLoginSort,
	}

	const handleSort = (columnId: string, order: SortOrder) => {
		setTotalDepositAmountSort(undefined)
		setLastDepositAtSort(undefined)
		setTotalDepositTimeSort(undefined)
		setLastLoginSort(undefined)

		switch (columnId) {
			case 'totalDepositAmount':
				setTotalDepositAmountSort(order)
				break
			case 'lastLogin_lastDepositAt':
				setLastDepositAtSort(order)
				break
			case 'totalDepositTime':
				setTotalDepositTimeSort(order)
				break
			case 'lastLogin_createdAt':
				setLastLoginSort(order)
				break
		}
	}

	const { data, isLoading } = useQueryGetInactivePlayer(payload)

	return (
		<PageContainer>
			<InactivePlayerListing
				data={data?.data || []}
				total={data?.total || 0}
				date={
					new Date(
						new Date(date).getMonth() !== new Date().getMonth()
							? endOfMonth(new Date(date))
							: new Date(),
					)
				}
				isLoading={isLoading}
				onSort={handleSort}
			/>
		</PageContainer>
	)
}

const GuardedInactivePlayerPage = withUserPermission(InactivePlayerPage, {
	permissionType: PermissionType.Read,
	permissionKey: [PermissionKeys.MANAGE_PLAYER],
})

export default GuardedInactivePlayerPage
